import { Room, RoomVisibility } from "@/types/rooms";
import { RoomCard } from "./RoomCard";
import { Plus } from "lucide-react";
import { useTranslation } from "@/context/LanguageContext";

interface Props {
  rooms: Room[];
  onCreateRoom: () => Promise<void> | void;
  onRenameRoom: (id: string, name: string) => Promise<void> | void;
  onDeleteRoom: (id: string) => Promise<void> | void;
  onChangeVisibility: (id: string, visibility: RoomVisibility) => Promise<void> | void;
}

export function RoomsGrid({
  rooms,
  onCreateRoom,
  onRenameRoom,
  onDeleteRoom,
  onChangeVisibility,
}: Props) {
  const { t } = useTranslation();
  
  return (
    <div className="w-full mb-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-6">
        {/* Create Room Card */}
        <button
          className="flex flex-col items-center justify-center p-4 border-2 border-dashed border-border rounded-2xl h-[158px] bg-card hover:border-border/60 transition-all"
          onClick={() => onCreateRoom()}
        >
          <div className="w-9 h-9 rounded-full bg-muted flex items-center justify-center mb-3">
            <Plus className="h-6 w-6 text-muted-foreground" />
          </div>
          <span className="text-sm text-muted-foreground font-medium">{t("dashboard.createRoom")}</span>
        </button>

        {rooms.map((room) => (
          <RoomCard
            key={room.id}
            room={room}
            onRename={onRenameRoom}
            onDelete={onDeleteRoom}
            onChangeVisibility={onChangeVisibility}
          />
        ))}
      </div>
    </div>
  );
}
